import type { UploadFile } from '../../../../../../../music24-api/src/kit/posts/listUploads';
import { getFullAPIFileURL } from '../../../../common/getFullAPIFileURL';
import { PromoteMediaDraft } from '../../draftStore';
import { inlineMediaUrl } from '../../inlineMediaUrl';
import { PickerFilter, pickerAspectLabel } from './pickerFiles';

export type { UploadFile };

/**
 * "Your uploads" in the Composer media picker (design assets-rethink a1, decision 8: no Library
 * page; the uploads of the artist are in the picker). `assets.uploads` lists them. Pure.
 */

/** The key of an upload in the picker selection. */
export const uploadPickerKey = (upload: Pick<UploadFile, 'uuid'>): string => `upload:${upload.uuid}`;

/** The uploads of one filter chip. */
export function filterPickerUploads(uploads: ReadonlyArray<UploadFile>, filter: PickerFilter): UploadFile[] {
  return filter === 'all' ? [...uploads] : uploads.filter((upload) => upload.mediaKind === filter);
}

/** The Composer media of an earlier upload. It belongs to no song, like a new upload. */
export function mediaDraftOfUploadFile(upload: UploadFile): PromoteMediaDraft {
  return {
    fileId: upload.fileId,
    fileUrl: getFullAPIFileURL(upload.url),
    ...(upload.mediaKind === 'image' ? { thumbnailUrl: inlineMediaUrl(upload.url) } : {}),
    kind: upload.mediaKind,
    aspect: pickerAspectLabel({ width: upload.width, height: upload.height }),
    width: upload.width,
    height: upload.height,
    durationSec: upload.mediaKind === 'video' ? upload.durationSec : null,
    sizeBytes: upload.sizeBytes,
    ...(upload.name === null ? {} : { label: upload.name }),
    title: '',
    artistName: '',
    renderedAt: upload.createdAt,
  };
}
